  <div class="col-xl-12 pb-0 mb-0" id="mernisQuery">
    <div class="alert notification p-1 m-0">

      <form [formGroup]="mernisForm" (ngSubmit)="onSubmit($event)" class=" ">
        <div class="row ">
          <div class="col-12 col-md-6 ps-2">
            <label for="idNumber" class="form-label required-star">
              {{ 'definition.staff.id-number' | translate }}
            </label>
            <input
              type="number"
              class="form-control"
              id="idNumber"
              formControlName="idNumber"
              [placeholder]="('definition.staff.id-number' | translate)"
              [readOnly]="isQueryMade && isSuccess"
              (input)="onInputChange($event)"
              [min]="0"
            />
            <div *ngIf="isSubmit && idNumber?.invalid && idNumber?.touched " class="required">
              {{ 'mernis.invalid-id' | translate }}
            </div>
          </div>
          <div  class="col-11 col-md-5" >
            <label class="form-label required-star" for="">
              {{ 'definition.staff.birth-date' | translate }}
            </label>
            <p-calendar
              dateFormat="dd.mm.yy"
              formControlName="birthDate"
              [showTime]="false"
              [showButtonBar]="true"
              appendTo="body"
              [disabled]="isQueryMade && isSuccess"
              [placeholder]="('form.date-plc' | translate)"
            />

            <div *ngIf="isSubmit && birthDate?.hasError('required') && birthDate?.touched" class="required">
              {{ "validation.required" | translate }}
            </div>

          </div>
          <div class="col-1 col-md-1 ps-1 pt-4">
            <button
              type="submit"
              class="btn btn-link ps-0"
              [ngClass]="getButtonClass()"
              [disabled]="!mernisForm.controls['idNumber'].value || !mernisForm.controls['birthDate'].value || isQueryMade && isSuccess"
            >
              <i class="fas fa-search" ></i>
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>

<app-loading [fullScreen]="true" [loading]="loading"></app-loading>
